import React, { useEffect, useRef } from 'react'
import {
  Box,
  Icon,
  Body2,
  Strong,
  AlignItems,
  Color,
  FontWeight,
  Text,
  Display,
  RadiusScale,
} from '@gousto-internal/citrus-react'
import { parseMessageContent } from '../utils/templateUtils'
import { trackNDDBannerTimer } from '../tracking'
import type { DeliveryEligibility, BannerConfig } from '../types'

export interface DeliveryDaysNDDBannerProps {
  bannerConfig?: BannerConfig | null
  eligibility?: DeliveryEligibility | null
  timeLeft?: number | null
}

export const DeliveryDaysNDDBanner: React.FC<DeliveryDaysNDDBannerProps> = ({
  bannerConfig,
  eligibility,
  timeLeft,
}) => {
  const hasTrackedBanner = useRef(false)

  const { message } = bannerConfig || {}

  // Track NDD Banner timer once when banner is rendered (parent controls visibility)
  useEffect(() => {
    if (message && eligibility && !hasTrackedBanner.current) {
      trackNDDBannerTimer(eligibility, timeLeft)
      hasTrackedBanner.current = true
    }
  }, [message, eligibility, timeLeft])

  if (!message) return null

  return (
    <Box
      display="flex"
      alignItems={AlignItems.FlexStart}
      paddingV={3}
      paddingH={4}
      bg={Color.Success_50}
      borderRadius={4 as RadiusScale}
      gap={3}
    >
      <Icon name="local_shipping" color={Color.Success_700} size={5} />
      <Body2 color={Color.ColdGrey_800} size={2}>
        {parseMessageContent(message, {
          strong: (content, index) => (
            <Strong fontWeight={FontWeight.SemiBold} key={index}>
              {content}
            </Strong>
          ),
          span: (content, index) => (
            <Text
              key={index}
              color={Color.Success_800}
              fontWeight={FontWeight.SemiBold}
              display={Display.Inline}
              size={2}
            >
              {content}
            </Text>
          ),
        })}
      </Body2>
    </Box>
  )
}
